<!--<section [class.m2app-dark]="formDarkTheme">-->
<div class="loginFormWrapper"
     [class.media-web-1270]="layoutMatches.isWeb1270Layout"
     [class.media-handset]="layoutMatches.isHandsetDefaultLayout">

  <section
    *ngIf="this.state=='tcs'"
    class="tcs-section">
    <mat-card class="tcsContainer">
      <section style="width:100%; margin-top:0px; text-align: center;">
        <img src="{{application.account.logo}}" class="login-logo" alt="Account Logo" />
      </section>
      <h1 class="text-center">Terms And Conditions</h1>
      <div style="height: 40vh; overflow: auto;" [innerHTML]="application.account.tos_message"></div>
      <section style="width:100%; margin-top:20px; text-align: center;">
      <!--<button mat-raised-button color="accent" (click)="displayTCs()">CLOSE</button>-->
      <!--<button mat-button (click)="displayTCs()" color="accent">-->
        <!--Close-->
      <!--</button>-->
      <a class="quicklink font16" (click)="displayTCs()">
        Close
      </a>
      </section>
    </mat-card>
    <div class="backContainer" *ngIf="application.account.back_link=='Y'">
      <a class="quicklink contrast-text" href="{{powered_by_url}}" target="_blank">
        {{powered_by_label}}
      </a>
    </div>
  </section>

  <section class="login-form-section" *ngIf="this.state!='tcs'">
    <div class="progress-bar-spinner" [class.dark-grey-red-theme]="true">
      <mat-progress-bar style="margin: 0px; padding: 0px;" *ngIf="application.isActiveRequest" color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-card class="login-form-card">
      <img src="{{application.account.logo}}" class="login-logo" alt="Account Logo" />

      <section *ngIf="this.state=='pwdreset'">
        <form [formGroup]="resetForm">
          <h1 class="text-center" i18n>Forgot password</h1>
          <mat-card style="padding: 0px; margin: 16px;" *ngIf="accessResetError">
            <mat-toolbar color="warn">
              <mat-icon style="vertical-align: middle;">error</mat-icon>
              &nbsp;&nbsp;&nbsp;<span style="font-size: 14px;">{{accessResetError}}</span>
            </mat-toolbar>
          </mat-card>
          <div class="form-group">

            <section color="accent" style="padding: 10px; margin-top: 10px; margin-bottom: 10px;">
              <span class="infoText">
                Enter your login or email address below and if you have an account we'll send an email with instructions on how to reset your password.
              </span>
            </section>

            <mat-form-field appearance="outline" class="form-field" color="accent">
              <mat-label>Enter your login or email</mat-label>
              <input matInput formControlName="recover_user" value="">
              <mat-error class="form-error" *ngIf="this.resetForm.controls['recover_user'].hasError('required')">Login or email is required</mat-error>
              <mat-error class="form-error" *ngIf="this.resetForm.controls['recover_user'].hasError('usernameinvalid')">Login or email should be between 3 and 128 characters</mat-error>
              <!--<mat-hint class="form-hint">System will send you a password reset instructions if administrator added your email to the User ID record.</mat-hint>-->
            </mat-form-field>
          </div>
          <div class="form-group" style="margin-top: 12px;">
            <mat-grid-list cols="2" rowHeight="4:1">
              <mat-grid-tile>
                <section class="leftLink">
                  <button mat-raised-button color="accent" (click)="sendReset()" style="display: none;">
                    <!-- equalt to VERIFY for form submit fix-->
                  </button>
                  <!--<button mat-button color="accent" (click)="displayReset()" style="text-align: left; padding-left: 0px;">-->
                    <!--Cancel-->
                  <!--</button>-->
                  <a class="quicklink font16" (click)="displayReset()">
                    Back
                  </a>
                </section>
              </mat-grid-tile>
              <mat-grid-tile>
                <section style="width:100%; text-align: right;">
                  <button mat-raised-button class="widerButton" color="accent" (click)="sendReset()">VERIFY</button>
                </section>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </form>
      </section>

      <section *ngIf="this.state=='accessreset_sent'">
        <h1 class="text-center">Check your email</h1>
        <section color="accent" style="padding: 8px; margin-top: 10px;">
          <!--<mat-icon class="infoIcon" color="accent">info</mat-icon>-->
          <span class="infoText">
            We have sent password reset instructions to your email address.
            If you did not receive an email on <span class="textCut userNameCut">{{this.resetForm.controls['recover_user'].value}}</span>,
            please contact your account administrator.
          </span>
        </section>
        <div class="form-group">
          <section style="width:100%; text-align: center; margin-top: 25px; margin-bottom: 15px;">
            <!--<button mat-raised-button color="accent" (click)="this.state='default'">Return to Sign-In</button>-->
            <a class="quicklink font16" (click)="this.state='default'">
              Back to Sign in
            </a>
          </section>
        </div>
      </section>

      <section *ngIf="this.state=='default'">
        <h1 class="text-center" i18n>Sign in</h1>
        <h2 class="text-center"><span i18n>to</span> {{application.account.label}}</h2>
        <div class="errorContainer" *ngIf="application.appError"> <mat-icon class="loginErrorIcon"  color="warn">error</mat-icon> {{application.appError | fsMessageTransform : 'login'}} </div>
        <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()" [class.noError]="!application.appError">
          <div class="form-group">
            <mat-form-field appearance="outline" class="form-field" color="accent">
              <mat-label>Login</mat-label>
              <input matInput formControlName="login" value=""
                     (keydown)="handleLoginFormKeyDown($event)">
              <mat-error class="form-error" *ngIf="this.loginFormErrors['login']">{{this.loginFormErrors['login']}}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field appearance="outline" class="form-field" color="accent">
              <mat-label>Password</mat-label>
              <input matInput formControlName="password" [type]="hidePwd ? 'password' : 'text'" value=""
                     (keydown)="handleLoginFormKeyDown($event)">
              <mat-icon
                style="display: inline-block"
                mat-icon matSuffix
                (mousedown)="hidePwd = !hidePwd"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidePwd"
                class="showHidePassword">
                {{hidePwd ? 'visibility_off' : 'visibility'}}
              </mat-icon>
              <mat-error class="form-error" *ngIf="this.loginFormErrors['password']">{{this.loginFormErrors['password']}}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group" *ngIf="this.loginForm.controls.tcs_checkbox" style="margin-bottom: 10px">
            <section class="leftLink">
              <div class="tosWrapper">
                <div class="tosCheckbox">
                  <mat-checkbox formControlName="tcs_checkbox" (change)="toggleTCs()"></mat-checkbox>
                </div>
                <div class="tosLabel">I accept <a class="quicklink font16" (click)="displayTCs()">Terms & Conditions</a></div>
              </div>
              <mat-error *ngIf="this.loginFormErrors['tcs_checkbox']" style="margin-top: 6px; font-size: 12px; clear: both;">{{this.loginFormErrors['tcs_checkbox']}}</mat-error>
            </section>
          </div>
          <div class="form-group" style="margin-bottom: 10px">
            <mat-grid-list cols="2" rowHeight="4:1">
              <mat-grid-tile>
                <section class="leftLink">
                  <a class="quicklink font16" (click)="displayReset()" i18n>
                    Forgot Password?
                  </a>
                </section>
              </mat-grid-tile>
              <mat-grid-tile>
                <section style="width:100%; text-align: right;">
                  <button class="widerButton" mat-raised-button color="accent" type="submit" (click)="onLoginSubmit()" i18n>LOGIN</button>
                </section>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </form>
      </section>

      <section *ngIf="this.state=='sms_login'">
        <h1 class="text-center">{{'club_registration_sms_form_top'|GetLabelPipe}}</h1>
        <h2 class="text-center">{{'club_registration_sms_form_bottom'|GetLabelPipe}}</h2>
        <div class="errorContainer" *ngIf="errMsg"> <mat-icon class="loginErrorIcon" color="warn">error</mat-icon> {{errMsg}} </div>
        <form [formGroup]="smsForm" (ngSubmit)="onDataSubmit()" [class.noError]="!application.appError">
          <div class="form-group" *ngIf="mode == 'default' || (mode == 'loading' && !smsForm.controls['code_number'].value)">
            <mat-form-field appearance="outline" class="form-field" color="accent">
              <mat-label>{{'phone_number_prompt'|GetLabelPipe}}</mat-label>
              <input matInput formControlName="phone_number" type="tel" maxlength="{{phoneInputLength}}"
                     (keydown)="handleLoginFormKeyDown($event)">
              <mat-error class="form-error" *ngIf="this.smsFormErrors['phone_number']">{{this.smsFormErrors['phone_number']}}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group" style="width: 160px;" *ngIf="mode == 'code_input' || (mode == 'loading' && smsForm.controls['code_number'].value)">
            <mat-form-field appearance="outline" class="form-field" color="accent">
              <mat-label>{{'code_number_prompt'|GetLabelPipe}}</mat-label>
              <input matInput formControlName="code_number" type="tel" maxlength="4"
                     (keydown)="handleLoginFormKeyDown($event)">
              <mat-error class="form-error" *ngIf="this.smsFormErrors['code_number']">{{this.smsFormErrors['code_number']}}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group" style="margin-bottom: 10px">
            <mat-grid-list cols="5" rowHeight="4:3">
              <mat-grid-tile colspan="2">
<!--                <section class="leftLink">-->
<!--                  <a class="quicklink font16" (click)="displayReset()" i18n>-->
<!--                    Forgot Password?-->
<!--                  </a>-->
<!--                </section>-->
              </mat-grid-tile>
              <mat-grid-tile colspan="3">
                <section style="width:100%;" class="flex-row-center flex-justify-end">
                  <button *ngIf="mode == 'default'"
                          [disabled]="mode == 'loading'"
                          class="widerButton" mat-raised-button color="accent" type="submit" (click)="onDataSubmit()">
                    {{'get_sms_code'|GetLabelPipe}}
                  </button>
                  <button *ngIf="mode == 'code_input'"
                          class="widerButton" mat-raised-button color="accent" type="submit" (click)="onDataSubmit()">
                    {{'validate_sms_code'|GetLabelPipe}}
                  </button>
                  <mat-spinner *ngIf="mode == 'loading'" color="accent" style="margin-right: 44px;"
                               class="file-icon accent-icon" [diameter]="24"></mat-spinner>
                </section>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </form>
      </section>
    </mat-card>
    <div class="backContainer contrast-text" *ngIf="application.account.back_link=='Y'">
      <!--  *ngIf="application.account.show_tos === 'Y' && application.account.ack_tos !== 'Y' && this.application.account.tos_message" -->
      <span *ngIf="application.account.show_tos === 'Y' && application.account.ack_tos !== 'Y' && this.application.account.tos_message" style="text-align: center"><a class="quicklink contrast-text" (click)="displayTCs()">Terms & Conditions</a> |</span>
      <a class="quicklink contrast-text" href="{{powered_by_url}}" target="_blank" i18n>
        {{powered_by_label}}
      </a>
    </div>
  </section>
  <section>
  </section>
</div>


<!--<button mat-button color="primary" [matMenuTriggerFor]="themeMenu" style="position: absolute; right : 0px; bottom: 0px;">Toggle Theme</button>-->
<!--<mat-menu #themeMenu="matMenu">-->
<!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-lightblue-red-theme'">-->
<!--<span>lightgrey-lightblue-red-theme</span>-->
<!--</button>-->
<!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-orange-red-theme'">-->
<!--<span>lightgrey-orange-red-theme</span>-->
<!--</button>-->
<!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-lightgreen-red-theme'">-->
<!--<span>lightgrey-lightgreen-red-theme</span>-->
<!--</button>-->
<!--<button mat-menu-item (click)="application.brandingTheme='dark-amber-red-theme'">-->
<!--<span>dark-amber-red-theme</span>-->
<!--</button>-->
<!--<button mat-menu-item (click)="application.brandingTheme='dark-grey-red-theme'">-->
<!--<span>dark-grey-red-theme</span>-->
<!--</button>-->
<!--</mat-menu>-->
